export default "__VITE_ASSET__CLSCKx9P__"